<template>
  <div class="disposePrescription">
    <template v-for="(row, index) in disposalList" :key="index">
      <DisposalItem class="mb12" isMobile :disposalItem="row" />
    </template>
    <EmptyImgh5 v-if="disposalList.length === 0"></EmptyImgh5>
  </div>
</template>

<script>
import DisposalItem from "@/components/patient/disposal.vue";
import { loadingStore } from "@/store/loading.js";

import { userStore } from "@/store/user.js";
import { handleList } from "@/api/patient.js";
export default {
  name: "disposalInfo",
  props: [],
  components: {
    DisposalItem,
  },
  data: function () {
    return {
      disposalList: [],
    };
  },
  setup() {
    let loading = loadingStore();
    return {
      loading,
    };
  },

  mounted: function () {
    this.getList();
  },
  methods: {
    getList() {
      let that = this;
      const aloginStoreuth = userStore();

      that.loading.showLoading();

      handleList({
        cusId: aloginStoreuth.cusId,
        corpId: aloginStoreuth.corpId,
      }).then((res) => {
        that.loading.hideLoading();

        const data = res.data.data || [];
        that.disposalList = data.filter((item) => item.status === "3");
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
